import { openDB } from 'idb';
import moment from "moment";
export class RemindersDB {
    static async initDB() {
        const db = await openDB('Reminders', 1, {
            upgrade(db) {
                const store = db.createObjectStore('reminders', {
                    keyPath: 'id',
                    autoIncrement: true,
                });
                store.createIndex('at', 'at');
            },
        });
        if (!db) {
            throw 'connection to db terminated';
        }
        this.db = db;
    }
    static async create(reminder) {
        return RemindersDB.db.add('reminders', Object.assign({}, reminder));
    }
    static async get(key) {
        return await RemindersDB.db.get('reminders', key);
    }
    static async getAllByExpirationDate() {
        return (await RemindersDB.db.getAllFromIndex('reminders', 'at')).filter(r => {
            return (!r.done || (r.doneAt && (moment().unix() - r.doneAt < 30 * 86000)));
        });
    }
    static async remove(key) {
        await RemindersDB.db.delete('reminders', key);
    }
    static async removeAll() {
        await RemindersDB.db.clear('reminders');
    }
    static async setDone(key) {
        const reminder = await RemindersDB.db.get('reminders', key);
        RemindersDB.db.put('reminders', Object.assign(Object.assign({}, reminder), { done: true, doneAt: moment().unix() }));
    }
    static async updatePending(key, data) {
        const { id } = await RemindersDB.db.get('reminders', key);
        RemindersDB.db.put('reminders', Object.assign(Object.assign({}, data), { id, done: false }));
    }
    static async setDueTime(key, at) {
        const reminder = await RemindersDB.db.get('reminders', key);
        RemindersDB.db.put('reminders', Object.assign(Object.assign({}, reminder), { at: at.unix(), done: false }));
    }
    static async dbCleanUp(maxDayAge = 15) {
        const reminders = await RemindersDB.db.getAll('reminders');
        reminders.forEach(p => {
            if (p.doneAt < ((~~(Date.now() / 1000)) - (maxDayAge * 86400)))
                RemindersDB.db.delete('reminders', p.id);
        });
    }
}
